import { Component, Host, h, Prop } from '@stencil/core';
export class Grid {
  getGridStyle() {
    let style = {};
    if (this.type === 'grid') {
      if (this.rows) {
        style.gridTemplateRows = `repeat(${this.rows}, 1fr)`;
      }
      if (this.cols) {
        style.gridTemplateColumns = `repeat(${this.cols}, 1fr)`;
      }
    }
    if (this.gap) {
      const gap = isNaN(Number(this.gap)) ? this.gap : this.gap + 'px';
      style = Object.assign(Object.assign({}, style), { '--sy-grid-gap': gap });
    }
    return style;
  }
  render() {
    return (h(Host, { style: this.getGridStyle() },
      h("slot", null)));
  }
  static get is() { return "sy-grid"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["scss/index.scss", "scss/_tokens.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["./scss/index.css", "./scss/_tokens.css"]
  }; }
  static get properties() { return {
    "type": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "'flex' | 'grid'",
        "resolved": "\"flex\" | \"grid\"",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the system used to build the grid: flexbox system or grid system."
      },
      "attribute": "type",
      "reflect": true
    },
    "fluid": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines if the grid will use all available width."
      },
      "attribute": "fluid",
      "reflect": true
    },
    "rows": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the number of rows of the grid. Only considered if type is 'grid'."
      },
      "attribute": "rows",
      "reflect": false
    },
    "cols": {
      "type": "number",
      "mutable": false,
      "complexType": {
        "original": "number",
        "resolved": "number",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Defines the number of columns of the grid. Only considered if type is 'grid'."
      },
      "attribute": "cols",
      "reflect": false
    },
    "gap": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Sets the gap size between collums and rows.\nIt must be a single number value."
      },
      "attribute": "gap",
      "reflect": true
    }
  }; }
}
